/**
 * @voltxampere/components — Wire-Node 4-pin junction (Sprint 23 B5)
 *
 * Wire-Node, schematic'te kabloların kavşaklarını görsel olarak
 * temsil eden bir öğedir. Elektriksel olarak 4 pin aynı düğüme
 * bağlandığında 0Ω elektriksel kavşak işlevi görür — pratikte
 * mevcut net layer (`circuit.nets[]`) zaten bu görevi yapar.
 * Wire-Node'un katma değeri yalnızca:
 *
 *   - Schematic okunabilirliği (4-yol kavşak göze hoş, "T-juction"
 *     veya "+ junction" çiziminde)
 *   - SPICE export sırasında "n0 n1 n2 n3" gibi 4-net birleşim
 *     bildirimi
 *
 * Engine stamp NO-OP'tur (admittance yok, source yok, augmented
 * row yok). Kullanıcı 4 pin'in TÜMÜNÜ aynı net'e bağlamak zorunda
 * değildir — bağlamazsa 4 izole net oluşur (kullanıcı hatası,
 * engine bunu enforce etmez).
 *
 * Pin layout: N (north) / S (south) / E (east) / W (west) — Sprint
 * 23 default 4-yol kavşak. UI gelecekte 3-yol "T-junction" varyantı
 * eklenirse `wire-node-t` ayrı tip olur.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
export const WireNodeParamsSchema = z.object({}).strict();
export const wireNodeDefinition = {
    type: "wire-node",
    category: "passive",
    displayName: { tr: "Kablo Düğümü", en: "Wire Node" },
    symbol: "•",
    // Sprint 24 A0 (bug_005 fix) — compass cross pin geometry
    // matching N/S/E/W labels. Sprint 23 B5'te side="left"/"right"
    // + offset=±10 ile 2×2 corner placement gönderilmişti;
    // /ultrareview Wire-Node henüz UI symbol library entry'siz
    // olduğu için user-visible bug değildi ama renderer landed
    // olunca "W" sağda görünecek + saved circuits routing yanlış
    // pin'lere giderdi. Cross center'da label=0 = pin axis center.
    pins: [
        { id: "n", side: "top", offset: 0, label: "N" },
        { id: "s", side: "bottom", offset: 0, label: "S" },
        { id: "e", side: "right", offset: 0, label: "E" },
        { id: "w", side: "left", offset: 0, label: "W" },
    ],
    parameterSchema: WireNodeParamsSchema,
    nonlinear: false,
};
//# sourceMappingURL=wire-node.js.map